import { number } from 'yup';

export const stringNumberSchema = number().transform((_, val) => (val === '' ? null : Number(val)));

export const nullableStringNumberSchema = number()
  .transform((_, val) => (val === '' ? null : Number(val)))
  .nullable();
